"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ResetIcon = function ResetIcon() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: 10,
    height: 10,
    viewBox: "0 0 10 10"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.874 1.252c-.039 0-.076.005-.113.013V.158c0-.144-.176-.209-.273-.112L2.8 1.75c-.065.065-.065.161-.016.226L4.488 3.68c.097.097.273.032.273-.112v-1.3c.037.008.074.013.113.013 1.844 0 3.345 1.5 3.345 3.345 0 1.844-1.5 3.345-3.345 3.345-1.844 0-3.345-1.5-3.345-3.345 0-.284-.23-.515-.514-.515-.285 0-.515.23-.515.515C.5 8.038 2.462 10 4.874 10s4.374-1.962 4.374-4.374-1.962-4.374-4.374-4.374",
    transform: "translate(-1189 -364) translate(0 63) translate(265 17) translate(0 237) translate(830 11) translate(0 27) translate(1 6) translate(93 3)"
  })));
};

var _default = ResetIcon;
exports["default"] = _default;